module.exports = __webpack_public_path__ + "img/专利证书07_基于负荷预测的能源系统优化运营平台v1.0.444c803e.png";